import React, { useState } from 'react';
import { Box, Card, CardContent, Typography, TextField, Button, InputAdornment, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/careoff-logo.svg';
import { loginVendor } from '../services/Api'; // Service registry

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [credentials, setCredentials] = useState({ userId: '', password: '' });
  const [error, setError] = useState(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const responseData = await loginVendor(credentials);
      const success = responseData?.success;
      const data = responseData?.data || {};
      const accessToken = data.accessToken;
      const refreshToken = data.refreshToken;
      const categoryType = data.categoryType;

      if (success && accessToken) {
        localStorage.setItem('accessToken', accessToken);
        if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
        if (categoryType) localStorage.setItem('categoryType', categoryType);
      }

      // Optionally decode JWT here and store user preferences mapped to specific User Contexts.
      navigate('/admin/dashboard');
    } catch (err) {
      console.error("Login failed", err);
      // Fallback for demo if the backend is dropping calls. You can replace/remove the mock jump
      const apiError = err.response?.data?.message || 'Invalid Mobile No. or Password';
      setError(apiError);
    }
  };

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: (theme) => theme.palette.primary.main,
      }}
    >
      <Card sx={{ maxWidth: 400, width: '100%', mx: 2, p: 2, borderRadius: 2, boxShadow: '0px 10px 30px rgba(0,0,0,0.1)' }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Box component="img" src={logo} alt="CareOff" sx={{ height: 48, mb: 1 }} />
          <Typography variant="body2" sx={{ mb: 4, textAlign: 'center', color: 'text.secondary' }}>
            Login to Vendor Dashboard
          </Typography>

          {error && (
            <Typography variant="body2" color="error" sx={{ mb: 2 }}>
              {error}
            </Typography>
          )}

          <form onSubmit={handleLogin} style={{ width: '100%' }}>
            <TextField
              fullWidth
              label="User ID (e.g mobile No)"
              name="userId"
              variant="outlined"
              margin="normal"
              value={credentials.userId}
              onChange={handleChange}
              required
            />
            <TextField
              fullWidth
              label="Password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              variant="outlined"
              margin="normal"
              value={credentials.password}
              onChange={handleChange}
              required
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={(e) => e.preventDefault()}
                        sx={{ color: 'action.active' }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              sx={{ mt: 3, py: 1.5 }}
            >
              Login
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Login;
